<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { isPill, isPlusUni } from 'src/helpers/interface_helpers';
	//Design system components
	import { Collapse } from '@Shelly/shelly-design-system';
	//Components
	import ManagePeripherals from './ManagePeripherals.svelte';
	import TemperatureUnit from './TemperatureSettings/TemperatureUnit.svelte';
	import WebHooksG2 from '../WebHooks/WebHooksG2/WebHooksG2.svelte';
	import SchedulesG2 from '../Schedules/SchedulesG2/SchedulesG2.svelte';
	import LoRaAddon from './LoRaAddon/LoRaAddon.svelte';
	import ManageAddons from './ManageAddons.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { AddonType } from 'src/helpers/addons/addon_support_helpers';

	export let device: Device;
	export let addonType: AddonType;

	const peripherals = getAddonStatus(device);
	const createCollapseSubMenu = () => {
		collapseSubMenu = [];
		if (peripherals.some((i) => i?.peripheralType == 'temperature')) {
			collapseSubMenu.push({
				component: TemperatureUnit,
				title: $format('sub_settings_title_temperature_unit', {
					default: 'Temperature units',
				}),
				props: { device },
				expanded: false,
			});
		}
		if (isPill(device?.type)) {
			return;
		}
		const switchPeripheral = peripherals.find((i) => i?.peripheralType == 'switch');
		if (switchPeripheral) {
			collapseSubMenu.push({
				component: SchedulesG2,
				title: $format('settings_title_schedule', {
					default: 'Schedule',
				}),
				props: { device, switchPeripheral },
				expanded: false,
			});
		}
		collapseSubMenu.push({
			component: WebHooksG2,
			title: $format('sub_settings_title_addon_actions_settings', {
				default: 'Actions',
			}),
			props: { device, peripheralsWebHook: true },
			expanded: false,
		});
	};

	let collapseSubMenu = [];

	if (peripherals.length) {
		createCollapseSubMenu();
	}
</script>

{#if !isPlusUni(device?.type) && !isPill(device?.type)}
	<ManageAddons {device} {addonType} />
{/if}

{#if addonType == 'LoRa'}
	<LoRaAddon {device} />
{:else if /^(sensor|prooutput)$/.test(addonType)}
	<ManagePeripherals
		{device}
		on:save={() => {
			collapseSubMenu.forEach((el) => {
				if (el?.child?.refresh) el.child.refresh();
			});
		}}
	/>
	{#each collapseSubMenu as { title, component, props, expanded }}
		<Collapse
			id="collapse-l4ncuwi"
			title={capFirstChar(title)}
			class="mb-s"
			{expanded}
			on:click={() => {
				if (expanded) {
					expanded = false;
				} else {
					collapseSubMenu.forEach((i) => {
						i.expanded = false;
					});
					expanded = true;
				}
			}}
		>
			<svelte:component this={component} {...props} />
		</Collapse>
	{/each}
{/if}
